export const TOGGLE_SECTION = 'TOGGLE_SECTION';

export const toggleSection = (id, toggleState) => ({
  type: TOGGLE_SECTION,
  id,
  toggleState,
});
